'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** ../~/react/react.js
 ** module id = 3
 ** module chunks = 2
 **/